import { TextInput } from "@JohnLewisPartnership/jl-design-system/dist/components/text-input/TextInput";
import { CloseOutlined as Close24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";
import { SearchOutlined as Search24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/SearchOutlined";
import styles from "./FacetSearch.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export const FacetSearch = ({
  label = "",
  facetSearchValue = "",
  setFacetSearchValue,
  isFilterDrawer = false,
  isLeftNavHeaderFlagOn = false,
}: {
  label: string;
  facetSearchValue: string;
  setFacetSearchValue: (arg: string) => void;
  isFilterDrawer?: boolean;
  isLeftNavHeaderFlagOn?: boolean;
}) => {
  const hasSearchIconVisible = !facetSearchValue;
  const hasClearButtonVisible = !!facetSearchValue;

  const handleSearch = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { value: newValue } = evt.target;
    setFacetSearchValue(newValue);
  };

  const handleClear = () => {
    setFacetSearchValue("");
  };

  const id = `facet-search-${label}`;
  const drawerLabel = isFilterDrawer ? "drawer-" : "";
  const placeholderText = `Search ${label}`;

  return (
    <div
      className={cx("container", {
        filterDrawer: isFilterDrawer,
        "container--lhn-header-on": isLeftNavHeaderFlagOn,
      })}
      data-testid={id}
    >
      <TextInput
        className={cx(styles.input, {
          "input--search-icon-showing": hasSearchIconVisible,
          "input--clear-button-showing": hasClearButtonVisible,
        })}
        id={drawerLabel + id}
        name={id}
        labelText={placeholderText}
        showLabel={false}
        value={facetSearchValue}
        placeholderText={placeholderText}
        onChange={handleSearch}
        autoComplete="off"
        type="text"
      />
      {hasSearchIconVisible && (
        <span className={styles.searchIcon}>
          <Search24PxOutlinedIcon size="medium" />
        </span>
      )}
      {hasClearButtonVisible && (
        <button
          onClick={handleClear}
          className={styles.clear}
          aria-label="Reset search"
        >
          <Close24PxOutlinedIcon size="medium" />
        </button>
      )}
    </div>
  );
};
